import { graphql } from 'react-relay';

export const complexLinkFragment = graphql`
    fragment ComplexLink_complexLink on ComplexLink {
        title
        text
        url
    }
`;
